import React from 'react';
import PostImageTemplate from "../../../components/pages/form/PostImageTemplate/PostImageTemplate";

const PostImageTemplatePage = () => {
    return <PostImageTemplate />
};

export default PostImageTemplatePage;
